import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Stack,
  Button,
  TextField,
  Typography,
  ToggleButton,
  ToggleButtonGroup
} from '@mui/material';
import { useState } from 'react';

export function ModalAjustes({
  open,
  onClose,
  state,
  fechaSeleccionada = null,
  díaBloqueado = false,
  subirFuturo = null
}) {
  const [tipoAjuste, setTipoAjuste] = useState('SOBRANTE');
  const [monto, setMonto] = useState('');
  const [descripcion, setDescripcion] = useState('');

  const handleRegistrar = async () => {
    if (!monto || isNaN(monto) || parseFloat(monto) <= 0) {
      alert('Monto inválido');
      return;
    }

    if (díaBloqueado) {
      alert('⛔ No puedes crear ajustes cuando hay un arqueo completado en el día');
      return;
    }

    const success = await state.registrarAjusteManual(tipoAjuste, parseFloat(monto), descripcion, 'EFECTIVO', fechaSeleccionada);

    if (success) {
      alert('Ajuste registrado');
      setMonto('');
      setDescripcion('');
      setTipoAjuste('SOBRANTE');
      onClose();
    }
  };

  if (!open) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Registrar Ajuste</DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Stack spacing={2}>
          <Box>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
              Tipo de Ajuste
            </Typography>
            <ToggleButtonGroup
              value={tipoAjuste}
              exclusive
              onChange={(e, val) => val && setTipoAjuste(val)}
              fullWidth
            >
              <ToggleButton value="SOBRANTE">Sobrante (+)</ToggleButton>
              <ToggleButton value="FALTANTE">Faltante (-)</ToggleButton>
            </ToggleButtonGroup>
          </Box>

          <TextField
            label="Monto"
            type="number"
            fullWidth
            value={monto}
            onChange={(e) => setMonto(e.target.value)}
            inputProps={{ step: '0.01' }}
          />

          <TextField
            label="Descripción (opcional)"
            fullWidth
            multiline
            rows={3}
            value={descripcion}
            onChange={(e) => setDescripcion(e.target.value)}
            placeholder="Ej: Diferencia encontrada en caja"
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          variant="contained"
          disabled={díaBloqueado || !monto}
          onClick={handleRegistrar}
        >
          Registrar Ajuste
        </Button>
      </DialogActions>
    </Dialog>
  );
}
